<template>
  <div class="ui-chess-item-grades" :style="gradesStyle">
    <div
      class="ui-chess-item-grades__item"
      v-for="grade in grades"
      :key="grade.name"
      :style="getGradeStyle(grade)"
    />
  </div>
</template>

<script>

export default {
  props: {
    grades: {
      type: Array,
      required: true
    }
  },
  computed: {
    gradesStyle () {
      return {
        gridTemplateColumns: this.grades.reduce((style, { count }) => `${style} ${count || 1}fr`, '')
      }
    },
    anyGradesCount () {
      return this.grades.reduce((anyGradesCount, { count }) => anyGradesCount + count, 0)
    }
  },
  methods: {
    getGradeStyle (grade) {
      return { backgroundColor: grade.color }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-chess-item-grades {
  display: grid;
  width: 100%;
  height: 6px;
}
</style>
